import { render, staticRenderFns } from "./LicenseAddEditDialog.vue?vue&type=template&id=228ee7dd&scoped=true&"
import script from "./LicenseAddEditDialog.vue?vue&type=script&lang=ts&"
export * from "./LicenseAddEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseAddEditDialog.vue?vue&type=style&index=0&id=228ee7dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ee7dd",
  null
  
)

export default component.exports